import type { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiFormControlLabel: Components<CssVarsTheme>['MuiFormControlLabel'] = {
  styleOverrides: {
    label: ({ theme }) => ({
      fontSize: '0.875rem',
      color: theme.vars.palette.text.primary
    }),
    root: {
      alignItems: 'center'
    }
  }
};
